/**
 * React Query hook for saving questionnaire progress
 */

import { useMutation } from '@tanstack/react-query';
import { saveQuestionnaire, SaveQuestionnaireRequest, SaveQuestionnaireResponse } from '../repository';
import { HttpError } from '../../../shared/httpTypes';

/**
 * Hook for saving questionnaire progress
 */
export function useSaveQuestionnaire() {
  return useMutation<SaveQuestionnaireResponse, HttpError, SaveQuestionnaireRequest>({
    mutationFn: (request) => saveQuestionnaire(request),
    onSuccess: (result) => {
      console.log('Questionnaire saved successfully:', result);
    },
    onError: (error: HttpError) => {
      console.error('Error saving questionnaire:', error);
    },
  });
}


